import { QueryNoteReceivableArgs } from '../generated/graphql';

export const noteReceivableKeys = {
  base: ['noteReceivableKeys'],
  noteReceivable: (args: QueryNoteReceivableArgs) => ['noteReceivable', ...noteReceivableKeys.base, args],
};
